module.exports = __webpack_public_path__ + "static/media/luis_castillo_resume_1.5cf19918.pdf";